import React from 'react';
import PropTypes from 'prop-types';
import Link from '@mui/material/Link';

/**
  @deprecated Use Facet Design's TextButton instead
 */
export const UnderlineButton = ({
  disabled, onClick, label, ...rest
}) => {
  return (
    <Link
      {...rest}
      sx={{
        fontWeight: 600,
      }}
      component="button"
      disabled={disabled}
      onClick={onClick}
    >{label}
    </Link>
  );
};

UnderlineButton.defaultProps = {
  onClick: undefined,
  disabled: false,
};

UnderlineButton.propTypes = {
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};
